Controller = App.loadClass 'core::Angular/Controller'

class exports.RatingsTabController extends Controller

    constructor: (@scope, @transitions, @repo, @modal, @state) ->
        super(@scope, @transitions)

        # scope methods
        @scope.openRatingsDialog = @openRatingsDialog
        @scope.hasLineup = @hasLineup

        # scope is inherited from the sidebar
        @scope.$watch 'selected.crop', (crop) =>
            @openRatingsDialog(crop)


    openRatingsDialog: (crop) =>
        # don't try to open the dialog without a valid crop selected
        if not crop?.lineups_id?
            return

        @state.go('portal.ratings.ratings.dialog', { crop: crop.name.toLowerCase() })

    hasLineup: (crop) =>
        return crop?.lineups_id?
